import React, { useContext } from 'react';
import Alert from '@material-ui/lab/Alert';
import DriveEtaIcon from '@material-ui/icons/DriveEta';
import PermContactCalendarIcon from '@material-ui/icons/PermContactCalendar';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import WorkIcon from '@material-ui/icons/Work';
import WarningIcon from '@material-ui/icons/Warning';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';


export const InspectionNotes = ({ list }) => {
    return (
        <div className="alert-container">
            {list?.length > 0 &&
                list?.map((q, index) => (
                    <Alert
                        key={q.id || index}
                        variant={'standard'}
                        className="alert-items"
                        style={{ backgroundColor: q.backColour, color: q.colour }}
                        severity="warning"
                        icon={
                            q.type == 'D' ? (
                                <LocalShippingIcon fontSize="inherit" style={{ color: q.colour }} />
                            ) : q.type == 'C' ? (
                                <PermContactCalendarIcon fontSize="inherit" style={{ color: q.colour }} />
                            ) : q.type == 'J' ? (
                                <WorkIcon fontSize="inherit" style={{ color: q.colour }} />
                            ) : q.type == 'V' ? (
                                <DriveEtaIcon fontSize="inherit" style={{ color: q.colour }} />
                            ) : q.type == 'CM' ? (
                                <ErrorOutlineIcon fontSize="inherit" style={{ color: q.colour }} />
                            ) : q.type == 'W' ? (
                                <DriveEtaIcon fontSize="inherit" style={{ color: q.colour }} />
                            ) : (
                                <WarningIcon fontSize="inherit" style={{ color: q.colour }} />
                            )
                        }
                    >
                        {q.type != 'W' ? q.title : ''}
                        {q.createdBy ? ` (${q.createdBy})` : ''}
                        {q.type != 'W' ? <br /> : null}
                        {q.description.split('\n').map((line, i) => (
                            <React.Fragment key={i}>
                                {line}
                                <br />
                            </React.Fragment>
                        ))}
                    </Alert>
                ))}
        </div>
    );
};

export default InspectionNotes;
